import { render, staticRenderFns } from "./movie.vue?vue&type=template&id=abd07dbe&scoped=true&"
import script from "./movie.vue?vue&type=script&lang=js&"
export * from "./movie.vue?vue&type=script&lang=js&"
import style0 from "./movie.vue?vue&type=style&index=0&id=abd07dbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd07dbe",
  null
  
)

export default component.exports